import { render, staticRenderFns } from "./UserManagementGrid.vue?vue&type=template&id=24b36c48&"
import script from "./UserManagementGrid.vue?vue&type=script&lang=ts&"
export * from "./UserManagementGrid.vue?vue&type=script&lang=ts&"
import style0 from "./UserManagementGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports